var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MKIcons',{staticClass:"bg-icon rounded-full mr-3-5 w-10 h-10 text-white text-xs",class:_vm.iconClass,style:(_vm.iconStyle),attrs:{"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }